import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import wineImg from '../../assets/wine.jpg';
import etiketeImg2 from '../../assets/etikete2.jpg';
import flasaImg1 from '../../assets/flasa.png';
import flasaImg2 from '../../assets/flasa2.png';
import flasaImg3 from '../../assets/flasa3.png';

export default function HomePage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  //const [activeHeroImage, setActiveHeroImage] = useState(0);

  const { t, i18n } = useTranslation('common');

  const isEnglish = i18n.language.startsWith('en');

  // const heroBottles = [
  // {
  //   image: flasaImg1,
  //   alt: isEnglish ? 'Bottle label mockup' : 'Mockup flaše sa etiketom',
  // },
  // {
  //   image: flasaImg2,
  //   alt: isEnglish ? 'Bottle label mockup' : 'Mockup flaše sa etiketom',
  // },
  // {
  //   image: flasaImg3,
  //   alt: isEnglish ? 'Bottle label mockup' : 'Mockup flaše sa etiketom',
  // },
  // ];

//   const previousHeroIndex =
//   activeHeroImage === 0 ? heroBottles.length - 1 : activeHeroImage - 1;

//   const nextHeroIndex =
//   activeHeroImage === heroBottles.length - 1 ? 0 : activeHeroImage + 1;

//   const getHeroBottleStyle = (index: number) => {
//   if(index === activeHeroImage){
//     return {
//       transform: 'translate(-50%, -50%) translateX(0px) translateY(0px) scale(1) rotate(0deg)',
//       opacity: 1,
//       filter: 'blur(0px)',
//       zIndex: 30,
//     };
//   }

//   if(index === previousHeroIndex){
//     return {
//       transform: 'translate(-50%, -50%) translateX(-210px) translateY(18px) scale(0.76) rotate(-12deg)',
//       opacity: 0.45,
//       filter: 'blur(0.4px)',
//       zIndex: 20,
//     };
//   }

//   if(index === nextHeroIndex){
//     return {
//       transform: 'translate(-50%, -50%) translateX(210px) translateY(18px) scale(0.76) rotate(12deg)',
//       opacity: 0.45,
//       filter: 'blur(0.4px)',
//       zIndex: 20,
//     };
//   }

//   return {
//     transform: 'translate(-50%, -50%) translateX(0px) translateY(40px) scale(0.65) rotate(0deg)',
//     opacity: 0,
//     filter: 'blur(4px)',
//     zIndex: 10,
//   };
// };

  const changeLanguage = (lang: 'sr' | 'en') => {
  localStorage.setItem('promedia-language', lang);
  i18n.changeLanguage(lang);
  setMobileMenuOpen(false); 
  };
  
  useEffect(() => {
    const elements = document.querySelectorAll(
      '.reveal, .reveal-left, .reveal-right'
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            entry.target.classList.add('reveal-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -40px 0px',
      }
    );

    elements.forEach((element) => {
      if(!element.classList.contains('reveal-visible')){
        observer.observe(element);
      }
    });

    return () => observer.disconnect();
  }, [i18n.language]);

  // useEffect(() => {
  //   if(heroBottles.length <= 1){
  //     return;
  //   }

  //   const interval = window.setInterval(() => {
  //     setActiveHeroImage((current) =>
  //       current === heroBottles.length - 1 ? 0 : current + 1
  //     );
  //   }, 5200);

  //   return () => window.clearInterval(interval);
  // }, [heroBottles.length]);


  const finishingItems = isEnglish
  ? [
      {
        title: 'Foil stamping',
        description: 'Classic foil, silk foil and 3D foil for refined metallic details.',
      },
      {
        title: 'Embossing',
        description: 'A tactile raised effect for selected parts of the label.',
      },
      {
        title: 'Screen printing',
        description: 'A stronger ink deposit for details that need more presence.',
      },
      {
        title: 'Raised / partial varnish',
        description: 'Glossy or raised accents for highlighting selected elements.',
      },
      {
        title: 'Matte / gloss finish',
        description: 'A final surface effect that can be matte or glossy.',
      },
      {
        title: 'Combined finishes',
        description: 'Multiple effects combined on one label for a more distinctive result.',
      },
    ]
  : [
      {
        title: 'Zlatotisak',
        description: 'Klasičan, silk foil i 3D za elegantne metalizovane detalje.',
      },
      {
        title: 'Blindruk',
        description: 'Reljefni efekat koji ističe izabrane delove etikete.',
      },
      {
        title: 'Sito',
        description: 'Izraženiji nanos boje za detalje kojima treba jači vizuelni efekat.',
      },
      {
        title: 'Bubreći / parcijalni lak',
        description: 'Sjajni ili reljefni akcenti za isticanje odabranih elemenata.',
      },
      {
        title: 'Mat / sjaj završna obrada',
        description: 'Završni efekat površine može biti mat ili sjajan.',
      },
      {
        title: 'Kombinovane dorade',
        description: 'Više dorada na jednoj etiketi za upečatljiviji finalni izgled.',
      },
    ];

  const faqItems = [
    {
      question: t('faq.items.digitalFlexo.question'),
      answer: t('faq.items.digitalFlexo.answer'),
    },
    {
      question: t('faq.items.smallRuns.question'),
      answer: t('faq.items.smallRuns.answer'),
    },
    {
      question: t('faq.items.filePreparation.question'),
      answer: t('faq.items.filePreparation.answer'),
    },
    {
      question: t('faq.items.finishing.question'),
      answer: t('faq.items.finishing.answer'),
    },
    {
      question: t('faq.items.price.question'),
      answer: t('faq.items.price.answer'),
    },
  ];

  const processSteps = isEnglish
  ? [
      {
        title: 'Inquiry',
        text: 'Send the print run, material information and the prepared artwork file.',
      },
      {
        title: 'Review and proposal',
        text: 'We review the request and suggest the suitable material, printing technology and finishing options.',
      },
      {
        title: 'File check',
        text: 'The artwork file is checked before production, especially layers, colors, bleed and finishing elements.',
      },
      {
        title: 'Production and delivery',
        text: 'After approval, the label goes into printing, finishing and delivery. A production tolerance of ±5% from the total print run is possible.',
      },
    ]
  : [
      {
        title: 'Upit',
        text: 'Pošaljite tiraž, informaciju o materijalu i fajl pripreme.',
      },
      {
        title: 'Pregled i predlog',
        text: 'Pregledamo zahtev i predlažemo odgovarajući materijal, tehnologiju štampe i dorade.',
      },
      {
        title: 'Provera pripreme',
        text: 'Pre izrade proverava se fajl pripreme, posebno lejeri, boje, prepust i elementi namenjeni doradi.',
      },
      {
        title: 'Izrada i isporuka',
        text: 'Nakon potvrde, etiketa ide u štampu, doradu i isporuku. Moguće je odstupanje od ±5% u odnosu na ukupan tiraž.',
      },
    ];

  return (
    <div className="min-h-screen bg-[#FAF8F3] text-[#1F2933]">
      {/* Navigation */}
      <nav className="fixed left-0 right-0 top-0 z-50 border-b border-[#E7E1D5] bg-[#FAF8F3]/90 backdrop-blur-xl">
        <div className="mx-auto max-w-7xl px-4 py-3 sm:px-6">
          <div className="flex items-center justify-between gap-4">
            <a href="#home" className="flex items-center gap-3">
              <img
                src="/promedia-logo.png"
                alt="Promedia Print logo"
                className="h-10 w-auto sm:h-12"
              />
            </a>

            <div className="hidden items-center gap-7 xl:flex">
              <a href="#home" className="text-sm font-semibold text-gray-800 transition hover:text-[#0F3328]">
                {t('nav.home')}
              </a>
              <a href="#technologies" className="text-sm font-semibold text-gray-800 transition hover:text-[#0F3328]">
                {t('nav.technologies')}
              </a>
              <a href="#finishing" className="text-sm font-semibold text-gray-800 transition hover:text-[#0F3328]">
                {t('nav.finishing')}
              </a>
              <a href="#process" className="text-sm font-semibold text-gray-800 transition hover:text-[#0F3328]">
                {isEnglish ? 'Process' : 'Proces saradnje'}
              </a>
              <a href="#preparation" className="text-sm font-semibold text-gray-800 transition hover:text-[#0F3328]">
                {t('nav.preparation')}
              </a>
              <a href="#faq" className="text-sm font-semibold text-gray-800 transition hover:text-[#0F3328]">
                {t('nav.faq')}
              </a>
              <a href="#contact" className="text-sm font-semibold text-gray-800 transition hover:text-[#0F3328]">
                {t('nav.contact')}
              </a>

              <div className="ml-1 flex items-center gap-1 rounded-full border border-[#E7E1D5] bg-white p-1">
                <button
                  onClick={() => changeLanguage('sr')}
                  className={`rounded-full px-3 py-1.5 text-xs font-bold transition ${
                    !isEnglish
                      ? 'bg-[#0F3328] text-white'
                      : 'text-gray-600 hover:text-[#0F3328]'
                  }`}
                >
                  SR
                </button>

                <button
                  onClick={() => changeLanguage('en')}
                  className={`rounded-full px-3 py-1.5 text-xs font-bold transition ${
                    isEnglish
                      ? 'bg-[#0F3328] text-white'
                      : 'text-gray-600 hover:text-[#0F3328]'
                  }`}
                >
                  EN
                </button>
              </div>
            </div>

            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="flex h-10 w-10 items-center justify-center rounded-full border border-[#E7E1D5] bg-white text-gray-900 xl:hidden"
              aria-label="Toggle menu"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {mobileMenuOpen && (
            <div className="mt-4 rounded-3xl border border-[#E7E1D5] bg-white p-5 shadow-xl xl:hidden">
              <div className="flex flex-col gap-4">
                <a href="#home" onClick={() => setMobileMenuOpen(false)} className="text-sm font-semibold text-gray-900">
                  {t('nav.home')}
                </a>
                <a href="#technologies" onClick={() => setMobileMenuOpen(false)} className="text-sm font-semibold text-gray-900">
                  {t('nav.technologies')}
                </a>
                <a href="#finishing" onClick={() => setMobileMenuOpen(false)} className="text-sm font-semibold text-gray-900">
                  {t('nav.finishing')}
                </a>
                <a href="#process" onClick={() => setMobileMenuOpen(false)} className="text-sm font-semibold text-gray-900">
                  {isEnglish ? 'Process' : 'Kako sarađujemo'}
                </a>
                <a href="#preparation" onClick={() => setMobileMenuOpen(false)} className="text-sm font-semibold text-gray-900">
                  {t('nav.preparation')}
                </a>
                <a href="#faq" onClick={() => setMobileMenuOpen(false)} className="text-sm font-semibold text-gray-900">
                  {t('nav.faq')}
                </a>
                <a href="#contact" onClick={() => setMobileMenuOpen(false)} className="text-sm font-semibold text-gray-900">
                  {t('nav.contact')}
                </a>

                <div className="grid grid-cols-2 gap-2 border-t border-[#E7E1D5] pt-4">
                  <button
                    onClick={() => changeLanguage('sr')}
                    className={`rounded-full px-4 py-2 text-sm font-bold transition ${
                      !isEnglish
                        ? 'bg-[#0F3328] text-white'
                        : 'bg-[#FAF8F3] text-gray-700'
                    }`}
                  >
                    Srpski
                  </button>
                  <button
                    onClick={() => changeLanguage('en')}
                    className={`rounded-full px-4 py-2 text-sm font-bold transition ${
                      isEnglish
                        ? 'bg-[#0F3328] text-white'
                        : 'bg-[#FAF8F3] text-gray-700'
                    }`}
                  >
                    English
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero */}
      <section id="home" className="relative overflow-hidden bg-[#FAF8F3] pt-28 sm:pt-32">
        <div className="absolute left-[-160px] top-[-120px] h-[520px] w-[520px] rounded-full bg-[#0F3328]/10 blur-3xl"></div>
        <div className="absolute right-[-180px] top-[180px] h-[520px] w-[520px] rounded-full bg-[#C9B88F]/25 blur-3xl"></div>
        <div className="absolute bottom-[-220px] left-1/2 h-[480px] w-[780px] -translate-x-1/2 rounded-full bg-white/80 blur-3xl"></div>

        <div className="relative mx-auto max-w-7xl px-4 pb-16 sm:px-6 sm:pb-24">
          <div className="mx-auto max-w-5xl text-center">
            <h1 className="font-display reveal mt-8 text-5xl font-bold leading-[0.92] tracking-[-0.055em] text-[#17211D] sm:text-7xl lg:text-8xl">
              {t('hero.title1')}
              <br />
              <span className="text-[#0F3328]">{t('hero.title2')}</span>
            </h1>

            <p className="reveal reveal-delay-1 mx-auto mt-7 max-w-3xl text-base leading-8 text-[#667085] sm:text-lg">
              {t('hero.description')}
            </p>

            <div className="reveal reveal-delay-2 mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href={`mailto:${t('contact.email.address')}?subject=${encodeURIComponent(
                  isEnglish ? 'Label inquiry' : 'Upit za etikete'
                )}&body=${encodeURIComponent(
                  isEnglish
                    ? 'Hello,\n\nI would like to send an inquiry for self-adhesive labels.\n\nCompany name:\nContact person:\nPhone:\nPrint run:\nMaterial:\n\nBest regards,'
                    : 'Poštovani,\n\nŽelim da pošaljem upit za samolepljive etikete.\n\nNaziv firme:\nKontakt osoba:\nTelefon:\nTiraž:\nMaterijal:\n\nSrdačan pozdrav,'
                )}`}
                className="inline-flex w-full items-center justify-center rounded-full bg-[#0F3328] px-7 py-4 text-sm font-bold text-white shadow-lg shadow-[#0F3328]/15 transition hover:-translate-y-0.5 hover:bg-[#183F34] sm:hidden"
              >
                {isEnglish ? 'Send inquiry' : 'Pošalji upit'}
                <i className="ri-mail-line ml-2"></i>
              </a>

              <a
                href="#contact"
                className="hidden items-center justify-center rounded-full bg-[#0F3328] px-7 py-4 text-sm font-bold text-white shadow-lg shadow-[#0F3328]/15 transition hover:-translate-y-0.5 hover:bg-[#183F34] sm:inline-flex"
              >
                {isEnglish ? 'Label inquiry' : 'Pošaljite upit'}
                <i className="ri-arrow-down-line ml-2"></i>
              </a>

              <a
                href="#preparation"
                className="inline-flex w-full items-center justify-center rounded-full border border-[#D6CDBD] bg-white px-7 py-4 text-sm font-bold text-[#17211D] transition hover:-translate-y-0.5 hover:border-[#0F3328] hover:text-[#0F3328] sm:w-auto"
              >
                {t('hero.secondaryCta')}
              </a>
            </div>
          </div>
        </div>
      </section>


      {/* vrtece flase */}
      {/* <section id="home" className="relative overflow-hidden bg-[#FAF8F3] pt-4 sm:pt-6">
          <div className="absolute left-[-160px] top-[-120px] h-[520px] w-[520px] rounded-full bg-[#0F3328]/10 blur-3xl"></div>
        <div className="absolute right-[-180px] top-[120px] h-[620px] w-[620px] rounded-full bg-[#C9B88F]/25 blur-3xl"></div>
        <div className="absolute bottom-[-220px] left-1/2 h-[480px] w-[780px] -translate-x-1/2 rounded-full bg-white/80 blur-3xl"></div>

        <div className="relative mx-auto grid max-w-7xl items-start gap-8 px-4 pb-10 pt-8 sm:px-6 sm:pb-14 sm:pt-10 lg:min-h-[620px] lg:grid-cols-[0.95fr_1.05fr] lg:items-center">
          <div className="relative z-20 max-w-3xl text-center lg:text-left">

            <h1 className="font-display reveal mt-4 text-5xl font-bold leading-[0.92] tracking-[-0.055em] text-[#17211D] sm:text-6xl lg:text-7xl xl:text-8xl">
              {t('hero.title1')}
              <br />
              <span className="text-[#0F3328]">{t('hero.title2')}</span>
            </h1>

            <p className="reveal reveal-delay-1 mt-7 max-w-2xl text-base leading-8 text-[#667085] sm:text-lg lg:mx-0">
              {isEnglish
                ? 'Printing that turns ideas into distinctive products'
                : 'Štampa koja ideju pretvara u prepoznatljiv proizvod'}
            </p>

            <div className="reveal reveal-delay-2 mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row lg:justify-start">
              <a
                href={`mailto:${t('contact.email.address')}?subject=${encodeURIComponent(
                  isEnglish ? 'Label inquiry' : 'Upit za etikete'
                )}&body=${encodeURIComponent(
                  isEnglish
                    ? 'Hello,\n\nI would like to send an inquiry for self-adhesive labels.\n\nCompany name:\nContact person:\nPhone:\nPrint run:\nMaterial:\nPrepared artwork file:\n\nBest regards,'
                    : 'Poštovani,\n\nŽelim da pošaljem upit za samolepljive etikete.\n\nNaziv firme:\nKontakt osoba:\nTelefon:\nTiraž:\nMaterijal:\nFajl pripreme:\n\nSrdačan pozdrav,'
                )}`}
                className="inline-flex w-full items-center justify-center rounded-full bg-[#0F3328] px-7 py-4 text-sm font-bold text-white shadow-lg shadow-[#0F3328]/15 transition hover:-translate-y-0.5 hover:bg-[#183F34] sm:hidden"
              >
                {isEnglish ? 'Send inquiry' : 'Pošalji upit'}
                <i className="ri-mail-line ml-2"></i>
              </a>

              <a
                href="#contact"
                className="hidden items-center justify-center rounded-full bg-[#0F3328] px-7 py-4 text-sm font-bold text-white shadow-lg shadow-[#0F3328]/15 transition hover:-translate-y-0.5 hover:bg-[#183F34] sm:inline-flex"
              >
                {isEnglish ? 'Contact details' : 'Kontakt podaci'}
                <i className="ri-arrow-down-line ml-2"></i>
              </a>

              <a
                href="#preparation"
                className="inline-flex w-full items-center justify-center rounded-full border border-[#D6CDBD] bg-white/85 px-7 py-4 text-sm font-bold text-[#17211D] backdrop-blur transition hover:-translate-y-0.5 hover:border-[#0F3328] hover:text-[#0F3328] sm:w-auto"
              >
                {t('hero.secondaryCta')}
              </a>
            </div>
          </div>

        <div className="reveal reveal-delay-1 relative z-10 hidden min-h-[520px] items-center justify-center lg:flex">
        <div className="absolute left-1/2 top-[48%] h-[520px] w-[520px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#0F3328]/10 blur-3xl"></div>

        <div className="relative h-[520px] w-full overflow-visible">
          {heroBottles.map((bottle, index) => (
            <img
              key={index}
              src={bottle.image}
              alt={bottle.alt}
              style={getHeroBottleStyle(index)}
              className="absolute left-1/2 top-[48%] h-[700px] w-[400px] object-contain drop-shadow-[0_40px_70px_rgba(15,51,40,0.25)] transition-[transform,opacity,filter] duration-[1500ms] ease-[cubic-bezier(0.22,1,0.36,1)]"
            />
          ))}
        </div>

          </div>
        </div>
      </section> */}

      {/* Technologies */}
      <section id="technologies" className="bg-white py-14 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <div className="reveal overflow-hidden rounded-[2.5rem] border border-[#E7E1D5] bg-[#FAF8F3] shadow-sm">
            <div className="grid gap-0 lg:grid-cols-[0.85fr_1.15fr]">
              <div className="bg-[#0F3328] p-7 text-white sm:p-10 lg:p-12">
                <p className="mb-5 text-sm font-extrabold uppercase tracking-[0.24em] text-white/55">
                  {t('nav.technologies')}
                </p>

                <h2 className="font-display text-4xl font-bold leading-tight tracking-[-0.03em] sm:text-5xl">
                  {t('technologies.title')}{' '}
                  <span className="text-white/75">
                    {t('technologies.titleBold')}
                  </span>
                </h2>

                <p className="mt-6 text-base leading-8 text-white/72 sm:text-lg">
                  {t('technologies.intro')}
                </p>
              </div>

              <div className="grid gap-0 divide-y divide-[#E7E1D5] bg-white sm:grid-cols-2 sm:divide-x sm:divide-y-0">
                <article className="p-7 sm:p-9 lg:p-10">
                  <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-full bg-[#0F3328] text-white">
                    <i className="ri-printer-line text-2xl"></i>
                  </div>

                  <h3 className="text-2xl font-extrabold text-[#17211D]">
                    {t('technologies.digital.title')}
                  </h3>

                  <p className="mt-4 text-sm leading-7 text-[#667085] sm:text-base">
                    {t('technologies.digital.description')}
                  </p>
                </article>

                <article className="p-7 sm:p-9 lg:p-10">
                  <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-full bg-[#0F3328] text-white">
                    <i className="ri-stack-line text-2xl"></i>
                  </div>

                  <h3 className="text-2xl font-extrabold text-[#17211D]">
                    {t('technologies.flexo.title')}
                  </h3>

                  <p className="mt-4 text-sm leading-7 text-[#667085] sm:text-base">
                    {t('technologies.flexo.description')}
                  </p>
                </article>
              </div>
            </div>
          </div>
        </div>
      </section>

        {/* Finishing */}
      <section id="finishing" className="relative overflow-hidden bg-[#0F3328] py-16 text-white sm:py-24">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_15%_20%,rgba(255,255,255,0.08),transparent_28%),radial-gradient(circle_at_85%_25%,rgba(214,205,189,0.16),transparent_30%)]"></div>

        <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
        <div className="mb-12 grid gap-6 lg:grid-cols-[0.85fr_1.15fr] lg:items-end">
          <div className="reveal-left">
            <p className="mb-4 text-sm font-extrabold uppercase tracking-[0.24em] text-white/55">
              {t('finishing.badge')}
            </p>

            <h2 className="font-display text-4xl font-bold leading-tight tracking-[-0.03em] sm:text-5xl">
              {t('finishing.title')}
            </h2>
          </div>

          <div className="reveal-right max-w-3xl">
            <div className="mt-5 rounded-2xl border border-white/10 bg-white/[0.06] p-5">
              <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-white/45">
                {isEnglish ? 'Specialty labels' : 'Specijaliteti'}
              </p>

              <p className="mt-3 text-sm leading-7 text-white/72 sm:text-base">
                {isEnglish
                  ? 'Our specialty is labels with multiple finishing effects, where printing, material and details work together as one complete visual impression.'
                  : 'Poseban akcenat stavljamo na etikete sa više dorada, gde štampa, materijal i detalji zajedno grade celovit vizuelni utisak.'}
              </p>
            </div>
          </div>
        </div>

          <div className="reveal overflow-hidden rounded-[2.75rem] border border-white/10 bg-white/[0.06] shadow-2xl shadow-black/20">
            <div className="grid gap-0 lg:grid-cols-[0.95fr_1.05fr]">
              <div className="relative min-h-[480px] overflow-hidden bg-[#09251D] p-6 sm:min-h-[640px] sm:p-10">
                <div className="absolute inset-0 opacity-18">
                  <img
                    src={wineImg}
                    alt=""
                    className="h-full w-full object-cover object-center"
                  />
                </div>

                <div className="absolute inset-0 bg-[#09251D]/55"></div>
                <div className="absolute left-1/2 top-1/2 h-[520px] w-[520px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-white/10 blur-3xl"></div>

                <div className="relative flex h-full items-center justify-center">
                  {/* <img
                    src={doradaImg}
                    alt={isEnglish ? 'Label finishing example' : 'Primer dorade etikete'}
                    className="max-h-[430px] w-auto object-contain drop-shadow-[0_45px_80px_rgba(0,0,0,0.45)] sm:max-h-[560px]"
                  /> */}
                </div>
              </div>

              <div className="relative bg-[#0F3328] p-7 sm:p-10 lg:p-12">
                <div className="mt-9 grid gap-3 sm:grid-cols-2">
                  {finishingItems.map((item, index) => (
                    <div
                      key={item.title}
                      className="group rounded-[1.35rem] border border-white/10 bg-white/[0.055] p-5 transition hover:-translate-y-0.5 hover:border-white/25 hover:bg-white/[0.08]"
                    >
                      <div className="mb-4 flex items-center justify-between gap-4">
                        <h4 className="text-base font-extrabold text-white">
                          {item.title}
                        </h4>

                        <span className="font-display text-2xl font-bold text-white/12 transition group-hover:text-white/20">
                          {String(index + 1).padStart(2, '0')}
                        </span>
                      </div>

                      <p className="text-sm leading-6 text-white/62">
                        {item.description}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
 
      {/* Process */}
      <section id="process" className="bg-[#FAF8F3] py-16 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <div className="mb-10 grid gap-6 lg:grid-cols-[0.8fr_1.2fr] lg:items-end">
            <div className="reveal-left">
              <p className="mb-4 text-sm font-extrabold uppercase tracking-[0.24em] text-[#0F3328]">
                {isEnglish ? 'Process' : 'Proces'}
              </p>

              <h2 className="font-display text-4xl font-bold tracking-[-0.03em] text-[#17211D] sm:text-5xl">
                {isEnglish ? 'How we work' : 'Kako sarađujemo'}
              </h2>
            </div>

            <p className="reveal-right max-w-3xl text-base leading-8 text-[#667085] sm:text-lg">
              {isEnglish
                ? 'The process is adapted to the label type, print run, material and finishing requirements.'
                : 'Proces se prilagođava tipu etikete, tiražu, materijalu i zahtevima za doradu.'}
            </p>
          </div>

          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {processSteps.map((step, index) => (
              <div
                key={step.title}
                className={`reveal reveal-delay-${Math.min(
                  index + 1,
                  4
                )} rounded-[1.75rem] border border-[#E7E1D5] bg-white p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-lg`}
              >
                <div className="mb-5 flex h-11 w-11 items-center justify-center rounded-full bg-[#0F3328] text-sm font-extrabold text-white">
                  {index + 1}
                </div>

                <h3 className="text-lg font-extrabold text-[#17211D]">
                  {step.title}
                </h3>

                <p className="mt-3 text-sm leading-7 text-[#667085]">
                  {step.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Preparation */}
      <section id="preparation" className="bg-white py-16 sm:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <div className="reveal overflow-hidden rounded-[2.5rem] bg-[#0F3328] shadow-2xl shadow-[#0F3328]/15">
            <div className="grid gap-0 lg:grid-cols-[1fr_0.9fr]">
              <div className="reveal-left p-7 text-white sm:p-10 lg:p-14">
                <p className="mb-5 text-sm font-extrabold uppercase tracking-[0.24em] text-white/55">
                  {t('preparation.badge')}
                </p>

                <h2 className="font-display text-4xl font-bold leading-tight tracking-[-0.03em] sm:text-5xl">
                  {t('preparation.title')}
                </h2>

                <p className="mt-6 max-w-2xl text-base leading-8 text-white/72 sm:text-lg">
                  {t('preparation.description')}
                </p>

                <div className="mt-8 grid gap-3 sm:grid-cols-2">
                  {[
                    t('preparation.points.format'),
                    t('preparation.points.colors'),
                    t('preparation.points.bleed'),
                    t('preparation.points.resolution'),
                  ].map((point) => (
                    <div key={point} className="flex items-start gap-3 rounded-2xl bg-white/7 p-4">
                      <i className="ri-check-line mt-0.5 text-lg text-white"></i>
                      <span className="text-sm leading-6 text-white/80">
                        {point}
                      </span>
                    </div>
                  ))}
                </div>

                <a
                  href="/documents/priprema-za-stampu.pdf"
                  download
                  className="mt-8 inline-flex items-center justify-center rounded-full bg-white px-7 py-4 text-sm font-extrabold text-[#0F3328] transition hover:-translate-y-0.5 hover:bg-[#FAF8F3]"
                >
                  {t('preparation.download')}
                  <i className="ri-download-line ml-2"></i>
                </a>
              </div>

              <div className="reveal-right relative min-h-[360px] bg-[#F2ECDF] p-7 sm:p-10">
                <div className="absolute inset-0 opacity-20">
                  <img
                    src={etiketeImg2}
                    alt=""
                    className="h-full w-full object-cover object-center"
                  />
                </div>

                <div className="relative flex h-full items-center justify-center">
                  <div className="w-full max-w-sm rounded-[2rem] border border-[#E7E1D5] bg-white p-7 shadow-2xl">
                    <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-[#0F3328] text-white">
                      <i className="ri-file-pdf-2-line text-3xl"></i>
                    </div>

                    <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-[#667085]">
                      PDF
                    </p>

                    <h3 className="mt-3 text-2xl font-extrabold text-[#17211D]">
                      {t('preparation.cardTitle')}
                    </h3>

                    <p className="mt-4 text-sm leading-7 text-[#667085]">
                      {t('preparation.cardText')}
                    </p>

                    <div className="mt-6 rounded-2xl bg-[#FAF8F3] p-4 text-sm font-bold text-[#0F3328]">
                      CMYK · bleed · rezna linija · fontovi
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="bg-[#FAF8F3] py-16 sm:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <div className="grid gap-10 lg:grid-cols-[0.75fr_1.25fr]">
            <div className="reveal-left">
              <p className="mb-4 text-sm font-extrabold uppercase tracking-[0.24em] text-[#0F3328]">
                FAQ
              </p>

              <h2 className="font-display text-4xl font-bold tracking-[-0.03em] text-[#17211D] sm:text-5xl">
                {t('faq.title')}
              </h2>

              <p className="mt-5 max-w-xl text-base leading-8 text-[#667085]">
                {t('faq.description')}
              </p>
            </div>

            <div className="reveal-right space-y-4">
              {faqItems.map((item, index) => (
                <div
                  key={index}
                  className="overflow-hidden rounded-[1.5rem] border border-[#E7E1D5] bg-white"
                >
                  <button
                    onClick={() => setOpenFaq(openFaq === index ? null : index)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left sm:px-6"
                  >
                    <span className="font-extrabold text-[#17211D]">
                      {item.question}
                    </span>

                    <i
                      className={`ri-arrow-down-s-line text-2xl text-[#0F3328] transition ${
                        openFaq === index ? 'rotate-180' : ''
                      }`}
                    ></i>
                  </button>

                  {openFaq === index && (
                    <div className="px-5 pb-5 text-sm leading-7 text-[#667085] sm:px-6 sm:text-base">
                      {item.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="bg-[#0F3328] py-16 text-white sm:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <div className="mb-12 grid gap-6 lg:grid-cols-[0.8fr_1.2fr] lg:items-end">
            <div className="reveal-left">
              <p className="mb-4 text-sm font-extrabold uppercase tracking-[0.24em] text-white/55">
                {t('nav.contact')}
              </p>

              <h2 className="font-display text-4xl font-bold leading-tight tracking-[-0.03em] sm:text-5xl">
                {t('contact.title')}{' '}
                <span className="text-white/75">{t('contact.titleBold')}</span>
              </h2>
            </div>

            <p className="reveal-right max-w-3xl text-base leading-8 text-white/70 sm:text-lg">
              {t('contact.description')}
            </p>
          </div>

          <div className="grid gap-6 lg:grid-cols-[0.85fr_1.3fr_0.85fr]">
            <a
              href={`mailto:${t('contact.email.address')}`}
              className="reveal reveal-delay-1 rounded-[2rem] border border-white/10 bg-white/7 p-7 transition hover:-translate-y-1 hover:bg-white/10 sm:p-8"
            >
              <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-white text-[#0F3328]">
                <i className="ri-mail-line text-2xl"></i>
              </div>

              <h3 className="text-xl font-extrabold">
                {t('contact.email.title')}
              </h3>

              <p className="mt-3 text-sm leading-7 text-white/65">
                {t('contact.email.description')}
              </p>

              <p className="mt-5 break-words font-extrabold text-white">
                {t('contact.email.address')}
              </p>
            </a>

            <div className="reveal reveal-delay-2 min-h-[330px] overflow-hidden rounded-[2rem] border border-white/10 bg-white/7">
              <iframe
                title="Location map"
                src={t('contact.location.mapEmbedUrl')}
                width="100%"
                height="100%"
                style={{ border: 0, minHeight: '330px' }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>

            <a
              href={`tel:${t('contact.phone.number').replace(/\s/g, '')}`}
              className="reveal reveal-delay-3 rounded-[2rem] border border-white/10 bg-white/7 p-7 transition hover:-translate-y-1 hover:bg-white/10 sm:p-8"
            >
              <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-white text-[#0F3328]">
                <i className="ri-phone-line text-2xl"></i>
              </div>

              <h3 className="text-xl font-extrabold">
                {t('contact.phone.title')}
              </h3>

              <p className="mt-3 text-sm leading-7 text-white/65">
                {t('contact.phone.description')}
              </p>

              <p className="mt-5 font-extrabold text-white">
                {t('contact.phone.number')}
              </p>
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#09251D] py-8 text-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <div className="flex flex-col justify-between gap-5 sm:flex-row sm:items-center">
            <div>
              <p className="font-display text-2xl font-bold">
                Promedia Print
              </p>

              <p className="mt-2 text-sm text-white/55">
                {isEnglish
                  ? 'Building reliable cooperation since 1991.'
                  : 'Kvalitetnu saradnju gradimo od 1991. godine.'}
              </p>
            </div>

            <div className="flex flex-col gap-1 text-sm text-white/55 sm:items-end">
              <a
                href={`mailto:${t('contact.email.address')}`}
                className="transition hover:text-white"
              >
                {t('contact.email.address')}
              </a>

              <a
                href={`tel:${t('contact.phone.number').replace(/\s/g, '')}`}
                className="transition hover:text-white"
              >
                {t('contact.phone.number')}
              </a>
            </div>
          </div>

          <div className="mt-6 border-t border-white/10 pt-5">
            <p className="text-xs text-white/40">
              © 2026 Promedia Print. Sva prava zadržana.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
